import { requestAsync } from 'redux-query';
import cfg from 'cfg';
import { UPDATE_DEFAULT } from 'dash-front/requery/actions';

const smpgUrl = cfg.apis.smpg;

export const fetchStats = publicationIds =>
    requestAsync({
        url: `${smpgUrl}/stats?resultIds=${JSON.stringify(publicationIds)}`,
        transform: res => ({
            postStats: res.reduce((acc, cur) => {
                // acc[cur.resultId] = cur;
                acc[cur.resultId] = cur;
                return acc;
            }, {})
        }),
        update: {
            postStats: UPDATE_DEFAULT.MERGE
        },
        force: true,
        queryKey: 'GET:postStats'
    });



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/actions/postStats.js
 **/